import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";

import PropTypes from "prop-types";
import cx from "classnames";

import buttonStyle from "assets/jss/material-dashboard-react/buttonStyle";

function RegularButton({ ...props }) {
    const {
        borderColor,
        children,
        classes,
        className,
        color,
        disabled,
        fullWidth,
        fab,
        noMargin,
        padding,
        noPadding,
        round,
        ...rest
    } = props;

    const btnClasses = cx(classes.button, className, {
        [classes[color]]: color,
        [classes[`simple${borderColor}`]]: color === "simple" && borderColor,
        [classes.fab]: fab,
        [classes.round]: round,
        [classes.fullWidth]: fullWidth,
        [classes.disabled]: disabled,
        [classes.noMargin]: noMargin,
        [classes.noPadding]: noPadding,
        [classes[padding]]: padding,
    });

    return (
        <Button {...rest} className={btnClasses}>
            {children}
        </Button>
    );
}

RegularButton.propTypes = {
    borderColor: PropTypes.oneOf(["primary", "secondary", "info", "success", "cyan", "rose"]),
    classes: PropTypes.object.isRequired,
    className: PropTypes.string,
    color: PropTypes.oneOf([
        "primary",
        "secondary",
        "info",
        "success",
        "warning",
        "danger",
        "rose",
        "white",
        "simple",
        "transparent",
    ]),
    disabled: PropTypes.bool,
    fab: PropTypes.bool,
    fullWidth: PropTypes.bool,
    noMargin: PropTypes.bool,
    noPadding: PropTypes.bool,
    padding: PropTypes.string,
    round: PropTypes.bool,
};

export default withStyles(buttonStyle)(RegularButton);
